import React from 'react';
import Svg, { Circle, Line } from 'react-native-svg';

type ListIconProps = {
  color: string;
};

const rowY = [6, 12, 18];

const ListIcon = ({ color }: ListIconProps) => {
  return (
    <Svg width={20} height={20} viewBox="0 0 24 24" fill="none">
      {rowY.map(y => (
        <React.Fragment key={y}>
          <Circle cx={4} cy={y} r={1.7} fill={color} />
          <Line
            x1={9}
            y1={y}
            x2={21}
            y2={y}
            stroke={color}
            strokeWidth={2.2}
            strokeLinecap="round"
          />
        </React.Fragment>
      ))}
    </Svg>
  );
};

export default ListIcon;
